export default __webpack_public_path__ + "static/cartoonsketch-58b26af176d9145bb48f9ff82fe6bb72.png";